import axios from "axios"
import headers from "../../util/headers"

export const getTagsForProgram = (baseUrl, query) => {
  const path = `${baseUrl}/backend/tags/search`
  return axios.get(path, { params: { query }, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
}

export const saveTag = (baseUrl, name) => {
  const path = `${baseUrl}/backend/tags`
  return axios.post(path, { name }, headers())
}

export const getTags = (baseUrl, filters) => {
  const path = `${baseUrl}/backend/tags`
  return axios.get(path, { params: { ...filters }, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
}

export const deleteTag = (baseUrl, id) => {
  const path = `${baseUrl}/backend/tags`
  return axios.delete(path, { params: { id }, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
}